/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { GoalRequirementResponse } from './GoalRequirementResponse';

/**
 * A consistency score requirement fulfillment
 */
export type RequirementFulfillmentResponse = {
    /**
     * The requirement type
     */
    type: RequirementFulfillmentResponse.type;
    /**
     * Deprecated; retained for wire compatibility. Always 0 — refill gating is no longer score-threshold based.
     */
    threshold: number;
    /**
     * Deprecated; retained for wire compatibility. Always empty.
     */
    goalRequirements: Array<GoalRequirementResponse>;
    fulfilled?: boolean;
};

export namespace RequirementFulfillmentResponse {

    /**
     * The requirement type
     */
    export enum type {
        GLP1_REFILL = 'GLP1_REFILL',
    }


}

